module.exports = __webpack_public_path__ + "static/img/share.ios.fefaa82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share.ios.png
// module id = 1412
// module chunks = 382